export const FIELD_REQUIRED_TEXT = "This field is required";

export function makeCharLimitText (charLimit) {
  return `Must be less than ${charLimit} characters.`;
}
